/* Nesta Designer Studio — theme behaviour */
(function () {
  'use strict';

  var money = function (cents) {
    return (window.Shopify && Shopify.formatMoney)
      ? Shopify.formatMoney(cents, window.themeMoneyFormat || '${{amount}}')
      : '₹' + (cents / 100).toFixed(2);
  };

  /* ---------- Drawer helpers ---------- */
  function openDrawer(el) { if (el) el.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function closeDrawer(el) { if (el) el.classList.remove('is-open'); document.body.style.overflow = ''; }

  /* ---------- Mobile nav ---------- */
  document.addEventListener('click', function (e) {
    var burger = e.target.closest('[data-mobile-nav-open]');
    if (burger) { openDrawer(document.querySelector('[data-mobile-nav]')); }
    if (e.target.closest('[data-mobile-nav-close]') || e.target.matches('[data-mobile-nav] .cart-overlay')) {
      closeDrawer(document.querySelector('[data-mobile-nav]'));
    }
  });

  /* ---------- Filter sidebar ---------- */
  var filterDrawer = document.querySelector('[data-filter-drawer]');
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-filter-open]')) { openDrawer(filterDrawer); }
    if (e.target.closest('[data-filter-close]') || (filterDrawer && e.target.matches('[data-filter-drawer] .filter-overlay'))) {
      closeDrawer(filterDrawer);
    }
  });

  /* ---------- Cart drawer ---------- */
  var cartDrawer = document.querySelector('[data-cart-drawer]');

  function refreshCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  function updateShipBar(cart) {
    if (!cartDrawer) return;
    var bar = cartDrawer.querySelector('[data-ship-bar]');
    if (!bar) return;
    var threshold = (window.freeShipThreshold || 0) * 100;
    if (threshold <= 0) { bar.style.display = 'none'; return; }
    bar.style.display = '';
    var total = cart.total_price || 0;
    var pct = Math.min(100, Math.round(total / threshold * 100));
    if (total < threshold) {
      bar.innerHTML = 'Add <strong>' + money(threshold - total) + '</strong> more for free shipping' +
        '<div class="ship-track"><div class="ship-fill" style="width:' + pct + '%"></div></div>';
    } else {
      bar.innerHTML = "You've unlocked <strong>free shipping</strong>!" +
        '<div class="ship-track"><div class="ship-fill" style="width:100%"></div></div>';
    }
  }

  function stopRecScroll() {
    if (window._recTimer) { clearInterval(window._recTimer); window._recTimer = null; }
  }
  function autoScrollRecs() {
    stopRecScroll();
    var wrap = cartDrawer && cartDrawer.querySelector('.cart-recs-inner');
    if (!wrap) return;
    var track = wrap.querySelector('.cart-recs-track');
    if (!track) return;
    var cards = track.querySelectorAll('.cart-rec');
    if (cards.length < 2) return;

    function step() { return cards.length > 1 ? (cards[1].offsetLeft - cards[0].offsetLeft) : cards[0].offsetWidth; }
    function next() {
      var max = track.scrollWidth - track.clientWidth;
      if (track.scrollLeft >= max - 4) { track.scrollTo({ left: 0, behavior: 'smooth' }); }
      else { track.scrollBy({ left: step(), behavior: 'smooth' }); }
    }
    function prev() {
      if (track.scrollLeft <= 4) { track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' }); }
      else { track.scrollBy({ left: -step(), behavior: 'smooth' }); }
    }
    function startTimer() { stopRecScroll(); window._recTimer = setInterval(next, 3500); }

    var pv = wrap.querySelector('[data-recs-prev]');
    var nx = wrap.querySelector('[data-recs-next]');
    if (pv) pv.onclick = function () { prev(); startTimer(); };
    if (nx) nx.onclick = function () { next(); startTimer(); };
    wrap.addEventListener('mouseenter', stopRecScroll);
    wrap.addEventListener('mouseleave', startTimer);
    startTimer();
  }

  function fetchRecs(cart) {
    if (!cartDrawer || !window.cartRecommendations) return;
    var recEl = cartDrawer.querySelector('[data-cart-recs]');
    if (!recEl) return;
    if (!cart.item_count) { recEl.innerHTML = ''; stopRecScroll(); return; }
    var pid = cart.items[0].product_id;
    fetch('/recommendations/products?product_id=' + pid + '&limit=5&intent=related&section_id=cart-recommendations', { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var inner = tmp.querySelector('.cart-recs-inner');
        recEl.innerHTML = inner ? inner.outerHTML : '';
        if (inner) setTimeout(autoScrollRecs, 150);
      })
      .catch(function () { recEl.innerHTML = ''; });
  }

  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count; el.style.display = cart.item_count ? '' : 'none';
    });

    if (!cartDrawer) return;
    var itemsEl = cartDrawer.querySelector('[data-cart-items]');
    var footEl = cartDrawer.querySelector('[data-cart-foot]');
    var titleCount = cartDrawer.querySelector('[data-cart-title-count]');
    var recEl = cartDrawer.querySelector('[data-cart-recs]');
    if (titleCount) titleCount.textContent = '(' + cart.item_count + ' ' + (cart.item_count === 1 ? 'item' : 'items') + ')';
    updateShipBar(cart);
    if (!itemsEl) return;

    if (!cart.item_count) {
      itemsEl.innerHTML = '<div class="cart-empty"><p>Your cart is empty.</p></div>';
      if (footEl) footEl.style.display = 'none';
      if (recEl) recEl.innerHTML = '';
      return;
    }
    if (footEl) footEl.style.display = '';

    itemsEl.innerHTML = cart.items.map(function (item) {
      var img = item.image ? sizedImage(item.image, 160) : '';
      var variant = item.options_with_values
        ? item.options_with_values.filter(function (o) { return o.value !== 'Default Title'; }).map(function (o) { return o.value; }).join(' / ')
        : '';
      return '<div class="cart-item" data-key="' + item.key + '">' +
        '<a href="' + item.url + '" class="ci-img">' + (img ? '<img src="' + img + '" alt="' + escapeHtml(item.product_title) + '">' : '') + '</a>' +
        '<div class="ci-body">' +
          '<div class="ci-top">' +
            '<a href="' + item.url + '" class="cart-item-title">' + escapeHtml(item.product_title) + '</a>' +
            '<div class="ci-price">' + money(item.final_line_price) + '</div>' +
          '</div>' +
          (variant ? '<div class="cart-item-variant">' + escapeHtml(variant) + '</div>' : '') +
          '<div class="ci-bottom">' +
            '<div class="ci-qty">' +
              '<button type="button" data-qty-change="' + item.key + '" data-qty-dir="dec" aria-label="Decrease">&minus;</button>' +
              '<span class="ci-qty-val">' + item.quantity + '</span>' +
              '<button type="button" data-qty-change="' + item.key + '" data-qty-dir="inc" aria-label="Increase">+</button>' +
            '</div>' +
            '<button class="cart-item-remove" data-remove="' + item.key + '" aria-label="Remove"><svg viewBox="0 0 24 24"><path d="M4 7h16M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2m2 0-1 13H7L6 7"/></svg></button>' +
          '</div>' +
        '</div>' +
      '</div>';
    }).join('');

    var subtotalEl = cartDrawer.querySelector('[data-cart-subtotal]');
    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) {
      e.preventDefault();
      refreshCart().then(function (cart) { openDrawer(cartDrawer); fetchRecs(cart); });
    }
    if (e.target.closest('[data-cart-close]') || (cartDrawer && e.target.matches('[data-cart-drawer] .cart-overlay'))) {
      closeDrawer(cartDrawer);
    }
    var rm = e.target.closest('[data-remove]');
    if (rm) { changeItem(rm.getAttribute('data-remove'), 0); }
    var qc = e.target.closest('[data-qty-change]');
    if (qc) {
      var valEl = qc.parentElement.querySelector('.ci-qty-val');
      var cur = parseInt(valEl ? valEl.textContent : '1', 10) || 1;
      var next = qc.getAttribute('data-qty-dir') === 'inc' ? cur + 1 : cur - 1;
      changeItem(qc.getAttribute('data-qty-change'), Math.max(0, next));
    }
  });

  function changeItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  /* ---------- Add to cart (product form + quick add) ---------- */
  function addToCart(formData, btn) {
    var original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (err) { throw err; });
      return r.json();
    }).then(function () {
      return refreshCart();
    }).then(function (cart) {
      if (btn) { btn.disabled = false; btn.textContent = original; }
      openDrawer(cartDrawer);
      fetchRecs(cart);
    }).catch(function (err) {
      if (btn) { btn.disabled = false; btn.textContent = original; }
      alert((err && err.description) || 'Could not add to cart.');
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    addToCart(new FormData(form), form.querySelector('[type="submit"]'));
  });

  // Quick add (single-variant products) from cards
  document.addEventListener('click', function (e) {
    var qa = e.target.closest('[data-quick-add]');
    if (!qa) return;
    var variantId = qa.getAttribute('data-quick-add');
    if (!variantId) return;
    e.preventDefault();
    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', 1);
    addToCart(fd, qa);
  });

  /* ---------- Quantity stepper ---------- */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (!step) return;
    var input = step.parentElement.querySelector('input');
    var val = parseInt(input.value, 10) || 1;
    val += parseInt(step.getAttribute('data-qty-step'), 10);
    input.value = Math.max(1, val);
  });

  /* ---------- Product gallery ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var mainImg = gallery.querySelector('[data-gallery-main]');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
    if (!mainImg || thumbs.length < 1) return;

    var index = 0;
    thumbs.forEach(function (t, i) { if (t.classList.contains('is-active')) index = i; });

    function show(i) {
      index = ((i % thumbs.length) + thumbs.length) % thumbs.length;
      var src = thumbs[index].getAttribute('data-full');
      if (src) { mainImg.src = src; mainImg.srcset = ''; }
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumbs[index].classList.add('is-active');
    }

    var autoplay = gallery.getAttribute('data-autoplay') === 'true';
    var secs = parseInt(gallery.getAttribute('data-autoplay-seconds'), 10) || 4;
    var timer = null;
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() { if (autoplay && thumbs.length > 1) { stop(); timer = setInterval(function () { show(index + 1); }, secs * 1000); } }
    function restart() { stop(); start(); }

    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); restart(); }); });
    var prev = gallery.querySelector('[data-gallery-prev]');
    var next = gallery.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { show(index - 1); restart(); });
    if (next) next.addEventListener('click', function () { show(index + 1); restart(); });

    gallery.addEventListener('mouseenter', stop);
    gallery.addEventListener('mouseleave', start);
    start();
  });

  /* ---------- Variant selection ---------- */
  document.querySelectorAll('[data-variant-selector]').forEach(function (root) {
    var variants = JSON.parse(root.querySelector('[data-variants-json]').textContent);
    var optionInputs = root.querySelectorAll('[data-option-index]');
    var idInput = root.querySelector('[data-variant-id]');
    var priceNow = root.querySelector('[data-price-now]');
    var priceWas = root.querySelector('[data-price-was]');
    var addBtn = root.querySelector('[data-add-btn]');
    var mainImg = document.querySelector('[data-gallery-main]');

    function selectedOptions() {
      var opts = [];
      optionInputs.forEach(function (input) {
        var idx = parseInt(input.getAttribute('data-option-index'), 10);
        var active = input.querySelector('.is-active');
        if (active) opts[idx] = active.getAttribute('data-value');
      });
      return opts;
    }

    function update() {
      var opts = selectedOptions();
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      if (!match) return;
      idInput.value = match.id;

      // label updates
      optionInputs.forEach(function (input) {
        var active = input.querySelector('.is-active');
        var label = input.closest('.option').querySelector('.selected-value');
        if (label && active) label.textContent = active.getAttribute('data-value');
      });

      if (priceNow) priceNow.textContent = money(match.price);
      if (priceWas) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          priceWas.textContent = money(match.compare_at_price);
          priceWas.style.display = '';
        } else { priceWas.style.display = 'none'; }
      }
      if (addBtn) {
        if (match.available) { addBtn.disabled = false; addBtn.textContent = addBtn.getAttribute('data-add-label'); }
        else { addBtn.disabled = true; addBtn.textContent = addBtn.getAttribute('data-soldout-label'); }
      }
      if (match.featured_image && mainImg) {
        mainImg.src = match.featured_image.src; mainImg.srcset = '';
      }
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-value]');
        if (!btn || btn.classList.contains('is-unavailable')) return;
        input.querySelectorAll('[data-value]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        update();
      });
    });

    update();
  });

  /* ---------- Collection infinite scroll ---------- */
  (function () {
    var grid = document.querySelector('[data-infinite-grid]');
    var sentinel = document.querySelector('[data-infinite-sentinel]');
    if (!grid || !sentinel || !('IntersectionObserver' in window)) return;

    var pagination = document.querySelector('[data-collection-pagination]');
    if (pagination) pagination.style.display = 'none';
    var loader = document.querySelector('[data-infinite-loader]');
    var nextUrl = sentinel.getAttribute('data-next-url');
    var loading = false;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting && !loading && nextUrl) loadMore(); });
    }, { rootMargin: '600px' });
    io.observe(sentinel);

    function loadMore() {
      loading = true;
      if (loader) loader.hidden = false;
      fetch(nextUrl, { headers: { 'Accept': 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-infinite-grid]');
          if (newGrid) {
            Array.prototype.slice.call(newGrid.children).forEach(function (card) { grid.appendChild(card); });
          }
          var newSentinel = doc.querySelector('[data-infinite-sentinel]');
          nextUrl = newSentinel ? newSentinel.getAttribute('data-next-url') : null;
          loading = false;
          if (loader) loader.hidden = true;
          if (!nextUrl) { io.disconnect(); }
          else { io.unobserve(sentinel); io.observe(sentinel); }
        })
        .catch(function () { loading = false; if (loader) loader.hidden = true; });
    }
  })();

  /* ---------- Predictive search ---------- */
  function escapeHtml(s) {
    return (s == null ? '' : String(s)).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function sizedImage(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function priceText(p) {
    if (p == null || p === '') return '';
    if (typeof p === 'number') return money(p);
    var s = String(p);
    if (/[^\d.,\s]/.test(s)) return s;            // already formatted (has a currency symbol)
    var f = parseFloat(s);
    return isNaN(f) ? '' : money(Math.round(f * 100));
  }

  function setupPredictive(input, resultsEl) {
    if (!input || !resultsEl) return;
    var timer = null, last = '';

    function render(products, query) {
      if (!products.length) {
        resultsEl.innerHTML = '<p class="search-status">No matches for &ldquo;' + escapeHtml(query) + '&rdquo;. Try another term.</p>';
        resultsEl.classList.add('is-open');
        return;
      }
      var html = products.map(function (p) {
        var img = sizedImage(p.image || (p.featured_image && p.featured_image.url) || '', 120);
        var price = priceText(p.price);
        return '<a class="search-item" href="' + p.url + '">' +
          (img ? '<img src="' + img + '" alt="" loading="lazy">' : '<div class="si-ph"></div>') +
          '<div><div class="si-title">' + escapeHtml(p.title) + '</div>' +
          (price ? '<div class="si-price">' + price + '</div>' : '') +
          '</div></a>';
      }).join('');
      html += '<a class="search-all" href="/search?q=' + encodeURIComponent(query) + '">See all results &rarr;</a>';
      resultsEl.innerHTML = html;
      resultsEl.classList.add('is-open');
    }

    function doSearch(q) {
      if (q.length < 2) { resultsEl.innerHTML = ''; resultsEl.classList.remove('is-open'); return; }
      resultsEl.innerHTML = '<p class="search-status">Searching&hellip;</p>';
      resultsEl.classList.add('is-open');
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last';
      fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          render((data.resources && data.resources.results && data.resources.results.products) || [], q);
        })
        .catch(function () { resultsEl.innerHTML = '<p class="search-status">Something went wrong. Please try again.</p>'; });
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      if (q === last) return;
      last = q;
      clearTimeout(timer);
      timer = setTimeout(function () { doSearch(q); }, 250);
    });
    input.addEventListener('focus', function () {
      if (resultsEl.innerHTML.trim()) resultsEl.classList.add('is-open');
    });
  }

  setupPredictive(document.querySelector('[data-hsearch-input]'), document.querySelector('[data-hsearch-results]'));

  // Close the results dropdown when clicking outside the header search
  document.addEventListener('click', function (e) {
    var hs = document.querySelector('.header-search');
    if (hs && !hs.contains(e.target)) {
      var r = hs.querySelector('[data-hsearch-results]');
      if (r) r.classList.remove('is-open');
    }
  });

  /* ---------- Newsletter (uses Shopify contact form) ---------- */
  // handled by native form post; optional success message via URL param
  if (location.search.indexOf('customer_posted=true') > -1) {
    var note = document.querySelector('[data-newsletter-success]');
    if (note) note.style.display = 'block';
  }

  refreshCart();
})();
